import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DeliveryService, DeliveryLoad, AssignedLoadsRequestPayload, LoadSummaryResponse, LoadSummaryRow, LoadSummaryTotals } from '../../services/delivery.service';
import { MessageDialogService } from '../../services/message-dialog';
import { firstValueFrom } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-load-summary',
  standalone: true,
  templateUrl: './load-summary-component.html',
  styleUrls: ['./load-summary-component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule
  ]
})
export class LoadSummaryComponent {
  loadIdInput: string = '';
  assignedLoads: DeliveryLoad[] = [];
  selectedLoadId: number | null = null;
  rows: LoadSummaryRow[] = [];
  totals: LoadSummaryTotals | null = null;
  loadName: string | null = null;

  constructor(
    private deliveryService: DeliveryService,
    private dialog: MessageDialogService
  ) {}

  async ngOnInit(): Promise<void> {
    // Load assigned loads (recent page 1)
    const payload: AssignedLoadsRequestPayload = { page: 1, limit: 50 };
    try {
      const res = await firstValueFrom(this.deliveryService.getAssignedLoads(payload));
      if (res.status === 'success' && res.loads) {
        this.assignedLoads = res.loads;
        // Auto-select first load if available
        if (this.assignedLoads.length > 0) {
          this.selectedLoadId = this.assignedLoads[0].id;
        }
      }
    } catch (_) {
      // ignore; selection will remain empty
    }
  }

  async fetchSummary(): Promise<void> {
    const id = this.selectedLoadId ?? Number(this.loadIdInput);
    if (!id || isNaN(id as any)) {
      await firstValueFrom(this.dialog.warning('Please select a Load.'));
      return;
    }

    try {
      const res: LoadSummaryResponse = await firstValueFrom(this.deliveryService.getLoadSummary(id));
      if (res.status !== 'success') {
        await firstValueFrom(this.dialog.error(res.message || 'Failed to load summary'));
        this.rows = [];
        this.totals = null;
        this.loadName = null;
        return;
      }
      this.rows = res.rows || [];
      this.totals = res.totals || null;
      this.loadName = res.load ? `${res.load.name} (${res.load.state})` : null;
    } catch (err: any) {
      const msg = err?.error?.message || err?.message || 'Error loading summary';
      await firstValueFrom(this.dialog.error(msg));
    }
  }
}


